// Colourful delivery badges so a customer recognises the option at a glance:
// carrier brand colours (Zásilkovna red, Česká pošta yellow/blue) with a
// simple glyph for *how* it arrives. Hand-drawn glyphs, not carrier logos.

const GLYPHS = {
  // a parcel/box — pickup point
  box: (c) => (
    <g fill="none" stroke={c} strokeWidth="1.8" strokeLinejoin="round">
      <path d="M12 3.5 19.5 7.5v9L12 20.5 4.5 16.5v-9Z" />
      <path d="M4.5 7.5 12 11.5l7.5-4M12 11.5v9" />
    </g>
  ),
  // a house — delivery to your door
  home: (c) => (
    <g fill="none" stroke={c} strokeWidth="1.8" strokeLinejoin="round" strokeLinecap="round">
      <path d="M4 11.5 12 5l8 6.5" />
      <path d="M6.5 10v9h11v-9" />
      <path d="M10.5 19v-5h3v5" />
    </g>
  ),
  truck: (c) => (
    <g fill="none" stroke={c} strokeWidth="1.8" strokeLinejoin="round">
      <path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z" />
      <circle cx="7" cy="17.5" r="1.6" fill={c} />
      <circle cx="17" cy="17.5" r="1.6" fill={c} />
    </g>
  ),
};

// What each delivery option looks like and what the customer should expect.
export const DELIVERY = {
  packeta_pickup: {
    bg: "#BA1B02", fg: "#fff", glyph: "box", brand: "Zásilkovna",
    how: "Pick a Z-BOX or pickup point near you. You'll get a text with a code when it's ready — collect it within 7 days.",
  },
  // Just "home delivery": who drives the van doesn't matter to the customer.
  packeta_home: {
    bg: "#3f3f46", fg: "#fff", glyph: "home", brand: "",
    how: "A courier brings it to your address and texts you on the day of delivery.",
  },
};

// Outside Czechia the same service goes by Packeta and a local partner
// (DPD, Hermes, InPost …) does the last mile.
const ABROAD = {
  packeta_pickup: {
    brand: "Packeta",
    how: "Pick a pickup point or parcel locker near you. You'll get a message with a code when it's ready to collect.",
  },
  packeta_home: {
    how: "A courier brings it to your door and gets in touch before delivering.",
  },
};

const BY_CARRIER = { packeta: "packeta_pickup" };

export function deliveryInfo({ methodId, carrier, country } = {}) {
  const base = DELIVERY[methodId] || DELIVERY[BY_CARRIER[carrier]] || { bg: "#3f3f46", fg: "#fff", glyph: "truck", brand: "", how: "" };
  return country && country !== "CZ" && ABROAD[methodId] ? { ...base, ...ABROAD[methodId] } : base;
}

// Official Zásilkovna icon from their e-shop cart logo pack
// (zasilkovna.cz/dokumenty-pro-partnery), served from /images/shipping/.
const LOGOS = { packeta: "/images/shipping/zasilkovna-icon.png" };

export default function ShippingIcon({ methodId, carrier, size = 36 }) {
  // The Zásilkovna logo marks pickup points (customers go to a Zásilkovna
  // place); home delivery gets a plain house badge.
  const home = String(methodId || "").includes("home");
  const logo = home ? null : LOGOS[carrier] || (String(methodId || "").startsWith("packeta") ? LOGOS.packeta : null);
  if (logo) {
    return (
      <img
        src={logo}
        alt="Zásilkovna"
        width={size}
        height={size}
        className="ship-icon"
        style={{ borderRadius: size / 4, flex: "none", objectFit: "contain", background: "#BA1B02" }}
      />
    );
  }
  const d = deliveryInfo({ methodId, carrier });
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" className="ship-icon">
      <rect width="24" height="24" rx="6" fill={d.bg} />
      <g transform="translate(2.4 2.4) scale(0.8)">{GLYPHS[d.glyph](d.fg)}</g>
    </svg>
  );
}
